import { setPickupOrdersTable } from './pickUpOrdersConfig';
import { setShipTable, setShipTable2 } from './shipConfig';
import { setDetailTable, setDetailTable2 } from './detailConfig';
import { shippedOrdersTable } from './shippedOrdersConfig';

export default function setTableCols (type = 'pickUpOrders') {
  const configs = {
    'pickUpOrders': setPickupOrdersTable.call(this),
    'ship': setShipTable.call(this),
    'ship2': setShipTable2.call(this),
    'detail': setDetailTable.call(this),
    'detail2': setDetailTable2.call(this),
    'shippedOrders': shippedOrdersTable.call(this),
  };

  configs[type].forEach(v => {
    if (!v.minWidth) {
      let title = v.label || v.title;

      v.minWidth = `${title.length * 16 + (v.sortable ? 30 : 20)}px`;
    }

    v.tooltip = true;
  });

  return configs[type];
}

